document.addEventListener("DOMContentLoaded", function () {
  const childLinks = document.querySelectorAll(".mega-menu__child-links a");
  const grandchildPanels = document.querySelectorAll(
    ".mega-menu__grandchild-panel"
  );
  const firstPanel = document.querySelector(".mega-menu__grandchild-panel");
  const firstChildLink = document.querySelector(".mega-menu__child-links a");

  // Helper function to reset all arrows
  function resetArrows() {
    childLinks.forEach((childLink) => {
      const defaultArrow = childLink.querySelector(".mega-menu__arrow");
      const hoverArrow = childLink.querySelector(".mega-menu__arrow--hover");
      if (defaultArrow) defaultArrow.style.display = "inline";
      if (hoverArrow) hoverArrow.style.display = "none";
    });
  }

  const megaMenus = document.querySelectorAll(".mega-menu");

  megaMenus.forEach((megaMenu) => {
    const firstPanel = megaMenu.querySelector(".mega-menu__grandchild-panel");
    const firstChildLink = megaMenu.querySelector(".mega-menu__child-links a");

    // Show the first panel by default for each mega menu
    if (firstPanel) {
      firstPanel.classList.add("active");
    }

    // Set the first child link's arrow to active by default for each mega menu
    if (firstChildLink) {
      const defaultArrow = firstChildLink.querySelector(".mega-menu__arrow");
      const hoverArrow = firstChildLink.querySelector(".mega-menu__arrow--hover");
      if (defaultArrow) defaultArrow.style.display = "none";
      if (hoverArrow) hoverArrow.style.display = "inline";
    }
  });

  childLinks.forEach((childLink) => {
    childLink.addEventListener("mouseenter", () => {
      const targetPanelId = `GrandchildPanel-${childLink.dataset.childlink}`;

      // Hide all grandchild panels
      grandchildPanels.forEach((panel) => {
        panel.classList.remove("active");
      });

      // Show the corresponding grandchild panel
      const targetPanel = document.getElementById(targetPanelId);
      if (targetPanel) {
        targetPanel.classList.add("active");
      }

      // Reset all arrows and set the hovered link's arrow to active
      resetArrows();
      const defaultArrow = childLink.querySelector(".mega-menu__arrow");
      const hoverArrow = childLink.querySelector(".mega-menu__arrow--hover");
      if (defaultArrow) defaultArrow.style.display = "none";
      if (hoverArrow) hoverArrow.style.display = "inline";
    });
  });

  // Keep the arrow active if the user stays in the right panel
  grandchildPanels.forEach((panel) => {
    panel.addEventListener("mouseenter", () => {
      const activeChildLink = document.querySelector(
        ".mega-menu__child-links a:hover"
      );
      if (activeChildLink) {
        const defaultArrow = activeChildLink.querySelector(".mega-menu__arrow");
        const hoverArrow = activeChildLink.querySelector(
          ".mega-menu__arrow--hover"
        );
        if (defaultArrow) defaultArrow.style.display = "none";
        if (hoverArrow) hoverArrow.style.display = "inline";
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const childLinks = document.querySelectorAll(".mega-menu__child-links a");
  const grandchildPanels = document.querySelectorAll(
    ".mega-menu__grandchild-panel"
  );

  // Function to reset all active classes
  function resetActiveClasses() {
    childLinks.forEach((childLink) => {
      childLink.classList.remove("mega-menu__link--level-2--active");
    });
  }

  // Function to update active classes based on the open panel
  function updateActiveClasses() {
    grandchildPanels.forEach((panel) => {
      if (panel.classList.contains("active")) {
        const childLinkId = panel.id.replace("GrandchildPanel-", "");
        const activeChildLink = document.querySelector(
          `.mega-menu__child-links a[data-childlink="${childLinkId}"]`
        );

        if (activeChildLink) {
          activeChildLink.classList.add("mega-menu__link--level-2--active");
        }
      }
    });
  }

  // Monitor changes to the active state of panels
  const observer = new MutationObserver(() => {
    resetActiveClasses();
    updateActiveClasses();
  });

  // Observe each grandchild panel for changes in the "active" class
  grandchildPanels.forEach((panel) => {
    observer.observe(panel, { attributes: true, attributeFilter: ["class"] });
  });

  // Initial setup
  updateActiveClasses();
});

// Menu division logic
document.addEventListener("DOMContentLoaded", function () {
  const grandchildPanels = document.querySelectorAll(
    ".mega-menu__grandchild-panel"
  );

  grandchildPanels.forEach((panel) => {
    const items = panel.querySelectorAll("li");
    const maxItemsPerDivision = 14;

    let currentDivision = document.createElement("ul");
    currentDivision.classList.add("list-unstyled");
    panel.appendChild(currentDivision);

    let headerCount = 0;
    let itemCount = 0; // Tracks the total number of items in the current division
    let currentHeaderGroup = []; // Tracks the current header group (header + sub-items)

    let lastSubmenuItem = null;

    items.forEach((item, index) => {
      const isHeader = item.classList.contains("mega-menu__header");

      // If a new [HEADER] is found, mark the last submenu item
      if (isHeader && lastSubmenuItem) {
        lastSubmenuItem.classList.add("last_submenu-item");
        lastSubmenuItem = null; // Reset for the next submenu
      }

      if (isHeader) {
        // If a new header is found, check if the current group fits in the division
        const groupSize = currentHeaderGroup.length;

        if (itemCount + groupSize > maxItemsPerDivision) {
          // If the group doesn't fit, start a new division
          currentDivision = document.createElement("ul");
          currentDivision.classList.add("list-unstyled");
          panel.appendChild(currentDivision);

          // Reset the item count for the new division
          itemCount = 0;
          headerCount = 0;
        }

        // Add the current group to the division
        currentHeaderGroup.forEach((groupItem) =>
          currentDivision.appendChild(groupItem)
        );
        itemCount += currentHeaderGroup.length;

        // Start a new header group
        currentHeaderGroup = [];
      }

      // Add the current item to the header group
      currentHeaderGroup.push(item);

      // If this is the last item in the list, ensure the group is added
      if (index === items.length - 1) {
        const groupSize = currentHeaderGroup.length;

        if (itemCount + groupSize > maxItemsPerDivision) {
          // Start a new division if the group doesn't fit
          currentDivision = document.createElement("ul");
          currentDivision.classList.add("list-unstyled");
          panel.appendChild(currentDivision);
        }

        // Add the remaining group to the division
        currentHeaderGroup.forEach((groupItem) =>
          currentDivision.appendChild(groupItem)
        );
      }

      // Update counters
      if (isHeader) {
        headerCount++;
      } else {
        lastSubmenuItem = item; // Track the last submenu item
      }

      // If this is the last item in the list, ensure it gets the class if applicable
      if (index === items.length - 1 && lastSubmenuItem) {
        lastSubmenuItem.classList.add("last_submenu-item");
      }
    }); // Ensure this closing bracket matches the `forEach` function
  });
});
